import { render } from "./GroupProductDetail.vue?vue&type=template&id=7c8f29f7&scoped=true"
import script from "./GroupProductDetail.vue?vue&type=script&lang=js"
export * from "./GroupProductDetail.vue?vue&type=script&lang=js"

import "./GroupProductDetail.vue?vue&type=style&index=0&id=7c8f29f7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8f29f7"]])

export default __exports__